import '../styles/HeroSection.css';
import * as React from "react";
import {Button, ButtonIcon, ButtonType} from "./Button";
import {Carousel, CarouselDirection} from "./Carousel";
import {Config} from "../Config";
import AvailabilityBadge from "./AvailabilityBadge";


interface HeroSectionProps {

}
export const HeroSection : React.FC<HeroSectionProps> = (props) => {
    function getItemsForCarousel() {
        return Config.CarouselProjects.map((project) => {
            return <div>
                <img src={project.url} alt={project.altText} />
            </div>
        });
    }
    function renderStar(i) {
        return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id={"mask0_232_7036" + i} style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="1" y="1" width="14" height="14">
                <path d="M14.6666 1.59668H1.33325V14.4033H14.6666V1.59668Z" fill="white"/>
            </mask>
            <g mask={"url(#mask0_232_7036" + i + ")"}>
                <path d="M14.6332 7.07002C14.5798 7.28935 14.4641 7.48855 14.2998 7.64335L12.0998 9.79002C12.0776 9.81342 12.0595 9.84049 12.0465 9.87002C12.04 9.90082 12.04 9.93255 12.0465 9.96335L12.5665 13.0034C12.6099 13.2273 12.5868 13.4591 12.4998 13.67C12.4196 13.8784 12.2777 14.0575 12.0932 14.1834C11.9138 14.3157 11.7018 14.3964 11.4798 14.4167H11.3932C11.1978 14.4171 11.0054 14.369 10.8332 14.2767L8.09984 12.85C8.07144 12.8336 8.03924 12.825 8.00651 12.825C7.97371 12.825 7.94157 12.8336 7.91317 12.85L5.17984 14.2834C4.97481 14.3907 4.74406 14.4392 4.51317 14.4234C4.28894 14.4042 4.07437 14.3235 3.89317 14.19C3.71038 14.0595 3.56917 13.8789 3.48651 13.67C3.40215 13.4585 3.37905 13.2274 3.41983 13.0034L3.93984 9.97002C3.94954 9.93969 3.94954 9.90702 3.93984 9.87669C3.92947 9.84729 3.91364 9.82015 3.89317 9.79669L1.69317 7.63669C1.53335 7.48215 1.42016 7.28582 1.36651 7.07002C1.30166 6.85255 1.30166 6.62087 1.36651 6.40338C1.43979 6.18931 1.57179 6.00015 1.74743 5.85752C1.92308 5.71489 2.13529 5.6245 2.35984 5.5967L5.35984 5.15671C5.38973 5.15596 5.41825 5.14404 5.43984 5.12335C5.46525 5.10388 5.48579 5.07879 5.49984 5.05003L6.89984 2.26337C6.99544 2.06348 7.14571 1.89477 7.33317 1.77671C7.47557 1.68679 7.63537 1.62801 7.80211 1.60427C7.96884 1.58053 8.13871 1.59233 8.30051 1.63893C8.46237 1.68553 8.61251 1.76588 8.74104 1.87465C8.86964 1.98342 8.97371 2.11816 9.0465 2.27003L10.4332 5.04335C10.4499 5.07414 10.4726 5.10132 10.4998 5.12335C10.5241 5.14399 10.5546 5.15579 10.5865 5.15671L13.6332 5.5967C13.8546 5.63034 14.0624 5.72501 14.2332 5.87005C14.4007 6.01472 14.5272 6.20097 14.5998 6.41005C14.6708 6.62292 14.6823 6.85109 14.6332 7.07002Z" fill="white"/>
            </g>
        </svg>;
    }

    return <div className="hero-section section scroll-zoom-out">
        <AvailabilityBadge label={"Available for new projects"}/>
        <div className={"text-part"}>
            <h1>
                We Design & Build Websites for Startups & Fast-Growing Brands
            </h1>
            <p className="margin font-body-L">
                We craft thoughtful, conversion-focused digital experiences. <br/>
                Combining strategic design with Framer and custom development.
            </p>
        </div>
        <Button classes={["btn-light", "btn-lg", "btn-border-animated-grey-rainbow"]}
                icon={ButtonIcon.UsTwo}
                type={ButtonType.CallToAction}
                border={true}
                onClick={"#" + Config.PageSections.Booking}
                secondContentChildren={"Pick a time"}
        >
            <div className={"book-a-call"}>Book a 20-min Intro Call</div>
            <div className={"availability-wrapper"}>
                <div className={"available"}>
                    <div className={"circle-1"}></div>
                    <div className={"circle-2"}></div>
                    <div className={"circle-3"}></div>
                </div>
                Check availability
            </div>
        </Button>
        <div className={"logos"}>
            <div className={"trust-stars"}>
                {renderStar(0)}
                {renderStar(1)}
                {renderStar(2)}
                {renderStar(3)}
                {renderStar(4)}
                <span>TRUSTED BY 20+ GROWING BRANDS WORLDWIDE</span>
            </div>
            <div className={"logos-row"}>
                {
                    Config.LogosToShowcase.map((logo, index) => (
                        <img key={index} src={logo} alt={`Logo ${index}`} className="marquee-logo" />
                    ))
                }
            </div>
        </div>
        <Carousel items={getItemsForCarousel()} direction={CarouselDirection.VerticalReverse} />
    </div>;
}
